import { render, staticRenderFns } from "./Pressandnews.vue?vue&type=template&id=3f62404c&scoped=true&"
import script from "./Pressandnews.vue?vue&type=script&lang=js&"
export * from "./Pressandnews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f62404c",
  null
  
)

export default component.exports